import React from 'react';

const Header = () => (
  <header className="mb-10 text-center">
    <h1 className="text-4xl font-bold text-indigo-700 mb-2">Shopify Market Basket Analyzer</h1>
    <p className="text-gray-600">Discover product associations in your Shopify store data</p>
  </header>
);

export default Header;
